import {addValidationRule} from 'formsy-react';

addValidationRule('isGreater', function(values, value, min) {
    return parseFloat(value) > min;
});

addValidationRule('notEmptyArray', function(values, value) {
    return !Array.isArray(value) || value.length === 0;
});


// WEBPACK FOOTER //
// ./src/helpers/validators.js